import AccessControl from './AccessControl';

export default AccessControl;
